import { useFeatureFlag } from '@/hooks/useFeatureFlag';

/**
 * Whether this author can be offered the guide at all.
 *
 * Its own flag is only half the answer: the run opens on Magic, and Magic is
 * behind two flags of its own that roll out independently. Without
 * `plannerAddContentEnabled` the Add events button the first card rings returns
 * null, and without `chatV2Enabled` the panel that card opens is never mounted,
 * so the run would spend its first step describing a planner the author does
 * not have. Off means the fallback landing applies, the same as the guide's own
 * flag being off.
 */
export const usePlannerOnboardingEnabled = () => {
  const guide = useFeatureFlag('plannerOnboardingEnabled');
  const addContent = useFeatureFlag('plannerAddContentEnabled');
  const chatV2 = useFeatureFlag('chatV2Enabled');

  return {
    isEnabled: guide.value && addContent.value && chatV2.value,
    // Any one still resolving leaves the answer unknown, not false: acting on a
    // false read here would drop a guide the author is entitled to.
    isLoading: guide.loading || addContent.loading || chatV2.loading,
  };
};
